import { resolveApiUrls } from './resolveApiUrls'

const { apiBaseUrl } = resolveApiUrls({
  stage: import.meta.env.VITE_STAGE,
  configuredApiBaseUrl: import.meta.env.VITE_API_BASE_URL,
})

export default apiBaseUrl
